<ng-content></ng-content>
<ng-content select="[suffix-icon]"></ng-content>